var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect } from 'react';
import { LendiGroupLeads, Origin } from '@lendi/lendigroup-leads-library';
import { useSession } from '@lendi/lala-react';
import { getAPIBaseURL } from '@lendi/lala-utils';
import { SmartChatTypes } from '../states';
import { useError } from '../../../../providers/ErrorProvider/context';
export var useLeads = function (_a) {
    var phoneNumber = _a.phoneNumber, email = _a.email, firstName = _a.firstName, chatDispatch = _a.chatDispatch;
    var _b = useSession(), environment = _b.environment, brand = _b.brand;
    var baseUrl = getAPIBaseURL(environment);
    var onException = useError().onException;
    // leads with phone number
    useEffect(function () {
        var sendPhoneLeads = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!phoneNumber) return [3 /*break*/, 4];
                        data = {
                            generatedAt: new Date().toISOString(),
                            mobileNumber: phoneNumber,
                            origin: Origin.Chat,
                            brand: brand,
                            accountOrigin: window.location.href,
                            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, LendiGroupLeads.sendLatestLead(baseUrl, data)];
                    case 2:
                        response = _a.sent();
                        chatDispatch({ type: SmartChatTypes.SAVE_LEADS, payload: response.data.id });
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        onException(new Error("@lendi/chat: useLeads: Could not send phone leads for the customer: ".concat(err_1)));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        sendPhoneLeads();
    }, [phoneNumber]);
    // TODO: there is no benefit of sending it as leads ignore subsequent leads, may be need to revist this
    // leads with phone number, firstname
    useEffect(function () {
        var sendFirstNameLeads = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!firstName) return [3 /*break*/, 4];
                        data = {
                            generatedAt: new Date().toISOString(),
                            firstName: firstName,
                            mobileNumber: phoneNumber,
                            origin: Origin.Chat,
                            brand: brand,
                            accountOrigin: window.location.href,
                            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, LendiGroupLeads.sendLatestLead(baseUrl, data)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        onException(new Error("@lendi/chat: useLeads: Could not send firstName 'leads' for the customer: ".concat(err_2)));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        sendFirstNameLeads();
    }, [firstName]);
    // TODO: there is no benefit of sending it as leads ignore subsequent leads, may be need to revist this
    // leads with phone number, firstname and email
    useEffect(function () {
        var sendEmailLeads = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!email) return [3 /*break*/, 4];
                        data = {
                            generatedAt: new Date().toISOString(),
                            firstName: firstName,
                            email: email,
                            mobileNumber: phoneNumber,
                            origin: Origin.Chat,
                            brand: brand,
                            accountOrigin: window.location.href,
                            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, LendiGroupLeads.sendLatestLead(baseUrl, data)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_3 = _a.sent();
                        onException(new Error("@lendi/chat: useLeads: Could not send email leads for the customer: ".concat(err_3)));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        sendEmailLeads();
    }, [email]);
};
//# sourceMappingURL=useLeads.js.map